<template>
  <div class="quill-editor">
    <slot name="toolbar"></slot>
    <div ref="editor"></div>
  </div>
</template>

<script>
  /* eslint-disable */
  // require sources
  import _Quill from 'quill'
  import defaultOptions from './options'
  import AXIOS from '@/integrations/axios'
  const Quill = window.Quill || _Quill

  // pollfill
  if (typeof Object.assign != 'function') {
    Object.defineProperty(Object, 'assign', {
      value(target, varArgs) {
        if (target == null) {
          throw new TypeError('Cannot convert undefined or null to object')
        }
        const to = Object(target)
        for (let index = 1; index < arguments.length; index++) {
          const nextSource = arguments[index]
          if (nextSource != null) {
            for (const nextKey in nextSource) {
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey]
              }
            }
          }
        }
        return to
      },
      writable: true,
      configurable: true
    })
  }

  // export
  export default {
    name: 'quill-editor',
    data() {
      return {
        _options: {},
        _content: '',
        defaultOptions
      }
    },
    props: {
      content: String,
      value: String,
      previewFetched: {
        type: Boolean,
        default: true,
        required: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      options: {
        type: Object,
        required: false,
        default: () => ({})
      },
      globalOptions: {
        type: Object,
        required: false,
        default: () => ({})
      }
    },
    mounted() {
      this.initialize()
    },
    beforeDestroy() {
      this.quill = null
      delete this.quill
    },
    methods: {
      // Init Quill instance
      initialize() {
        if (this.$el) {
          // Options
          this._options = Object.assign({}, this.defaultOptions, this.globalOptions, this.options)

          // Instance
          this.quill = new Quill(this.$refs.editor, this._options)

          this.quill.enable(false)

          // Set editor content
          if (this.value || this.content) {
            this.quill.pasteHTML(this.value || this.content)
          }

          // Disabled editor
          if (!this.disabled) {
            this.quill.enable(true)
          }

          // Mark model as touched if editor lost focus
          this.quill.on('selection-change', range => {
            if (!range) {
              this.$emit('blur', this.quill)
            } else {
              this.$emit('focus', this.quill)
            }
          })

          // Update model if text changes
          this.quill.on('text-change', (delta, oldDelta, source) => {
            let html = this.$refs.editor.children[0].innerHTML
            const quill = this.quill
            const text = this.quill.getText()
            if (html === '<p><br></p>') html = ''
            this._content = html
            this.$emit('input', this._content)
            this.$emit('change', {html, text, quill})
          })

          this.quill.clipboard.addMatcher(Node.ELEMENT_NODE, function (node, delta) {
            let plaintext = node.innerText
            let Delta = Quill.import('delta')
            return new Delta().insert(plaintext)
          })

          let QLink = Quill.import('formats/link')
          let QImage = Quill.import('formats/image')

          class CustomLink extends QLink {
            static sanitize(url) {
              let value = super.sanitize(url)
              if (value) {
                for (let i = 0; i < this.PROTOCOL_WHITELIST.length; i++) {
                  if (value.startsWith(this.PROTOCOL_WHITELIST[i])) {
                    return value
                  }
                }
                return `http://${value}`
              }
              return value
            }
          }

          class CustomImage extends QImage {
            static create(value) {
              const node = super.create(value)
              if (typeof value === 'string') {
                let imgSrc = this.sanitize(value)
                if (imgSrc.length > 10240) {
                  node.setAttribute('src', '')
                  Swal.fire({
                    icon: 'error',
                    title: 'Image too big',
                    text: 'Insert less image, or upload any image instead of direct insert into editor'
                  })
                } else {
                  node.setAttribute('src', imgSrc)
                }
              }
              return node
            }
          }
          Quill.register(CustomLink, true)
          Quill.register(CustomImage, true)

          // Emit ready event
          this.$emit('ready', this.quill)

          setTimeout(() => {
            if (document.querySelector('.ql-picker.ql-color'))
              document.querySelector('.ql-picker.ql-color').addEventListener('click', () => {
                if (document.querySelector('.ql-toolbar')) document.querySelector('.ql-toolbar').scrollLeft = 0
              })
            if (document.querySelector('.ql-picker.ql-background'))
              document.querySelector('.ql-picker.ql-background').addEventListener('click', () => {
                if (document.querySelector('.ql-toolbar')) document.querySelector('.ql-toolbar').scrollLeft = 0
              })
            ;['keyup', 'blur'].forEach(event => {
              if (document.querySelector('.ql-editor')) {
                document.querySelector('.ql-editor').addEventListener(event, e => {
                  if (e.keyCode == 13 || e.keyCode == 32 || e.type !== 'keyup') {
                    // Highlight links
                    let $content = this.$refs.editor.children[0].innerHTML
                    let pattern = /(\S+\.[\w\/-]+\?\w+=\S+[\s<])|(\S+\.\S+\/[\s<])|(www\.\S+\.\S+[\s<])|(https?:\/\/\w+\.\S+[\s<])/g
                    ;[
                      ...$content
                        .replace(/<a.+?\/a>/g, '')
                        .replace(/<\/?p>/g, ' ')
                        .matchAll(pattern)
                    ].forEach(item => {
                      let position = this.quill.getSelection()
                      let url = item[0].substr(0, item[0].length - 1)
                      let fullUrl = url.indexOf('http') === 0 ? url : 'http://' + url
                      let link = '<a href="' + fullUrl + '" target="_blank">' + url + '</a>'

                      this.$refs.editor.children[0].innerHTML = $content.replace(url, link)

                      if (!this.previewFetched) {
                        this.$emit('beforePreviewFetch')
                        AXIOS.post('/pwa/get-url-preview', {url: fullUrl}).then(res => {
                          if (res.data.success) this.$emit('preview', res.data)
                        })
                      }

                      if (e.type === 'keyup') {
                        setTimeout(() => {
                          this.quill.setSelection(position.index)
                        }, 50)
                      }
                    })
                    /* ------------------ */

                    // Get links preview
                    // if (!this.previewFetched) {
                    //   this.$emit('beforePreviewFetch')
                    //   let content = $content.replace(/[\n\t\r\>\<]+/g, ' ').substring(0, e.target.selectionStart)
                    //   let pattern = /(\S+\.[\w\/-]+\?\w+=\S+[\s<])|(\S+\.\S+\/[\s<])|(www\.\S+\.\S+[\s<])|(https?:\/\/\w+\.\S+[\s<])/g
                    //   let link = content.match(pattern)

                    //   if (link && link[1]) {
                    //     AXIOS.post('/pwa/get-url-preview', {url: link[1]}).then(res => {
                    //       if (res.data.success) this.$emit('preview', res.data)
                    //     })
                    //   }
                    // }
                  }
                })
              }
            })
          }, 100)
        }
      },
      getLinks() {
        let $content = this.$refs.editor.children[0].innerHTML
        let pattern = /(\S+\.[\w\/-]+\?\w+=\S+[\s<])|(\S+\.\S+\/[\s<])|(www\.\S+\.\S+[\s<])|(https?:\/\/\w+\.\S+[\s<])/g

        ;[
          ...$content
            .replace(/<a.+?\/a>/g, '')
            .replace(/<\/?p>/g, ' ')
            .matchAll(pattern)
        ].forEach(item => {
          let position = this.quill.getSelection()
          let url = item[0].substr(0, item[0].length - 1)
          let fullUrl = url.indexOf('http') === 0 ? url : 'http://' + url
          let link = '<a href="' + fullUrl + '" target="_blank">' + url + '</a>'

          this.$refs.editor.children[0].innerHTML = $content.replace(url, link)
        })
      },
      getPreviews() {
        if (!this.previewFetched) {
          return new Promise(async (resolve, reject) => {
            let $content = this.$refs.editor.children[0].innerHTML
            let content = $content.replace(/[\n\t\r\>\<]+/g, ' ').substring(0, this.$refs.editor.selectionStart)
            let pattern = /(\S+\.[\w\/-]+\?\w+=\S+[\s<])|(\S+\.\S+\/[\s<])|(www\.\S+\.\S+[\s<])|(https?:\/\/\w+\.\S+[\s<])/g
            let link = content.match(pattern)

            if (link && link[1]) {
              this.$emit('beforePreviewFetch')
              AXIOS.post('/pwa/get-url-preview', {url: link[1]})
                .then(res => {
                  if (res.data.success) this.$emit('preview', res.data)
                  resolve()
                })
                .catch(err => {
                  reject(err)
                })
            } else {
              resolve()
            }
          })
        }
      }
    },
    watch: {
      // Watch content change
      content(newVal, oldVal) {
        if (this.quill) {
          if (newVal && newVal !== this._content) {
            this._content = newVal
            this.quill.pasteHTML(this._content)
          } else if (!newVal) {
            this.quill.setText('')
          }
        }
      },
      // Watch content change
      value(newVal, oldVal) {
        if (this.quill) {
          if (newVal && newVal !== this._content) {
            this._content = newVal
            this.quill.pasteHTML(this._content)
          } else if (!newVal) {
            this.quill.setText('')
          }
        }
      },
      // Watch disabled change
      disabled(newVal, oldVal) {
        if (this.quill) {
          this.quill.enable(!newVal)
        }
      }
    }
  }
</script>
